import React from 'react'
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
} from "@material-tailwind/react";
import '../../styles/cardStyles.css';
import { Link } from 'react-router';

const TreatmentCard = ({ treatmentDetails }) => {
    return (
        <Card className="shadow-lg hover:shadow-lg rounded-none hover:shadow-black/30 transition-shadow duration-500 data-card">
            <CardHeader className="relative mt-3 h-60 rounded-none">
                <img
                    src={treatmentDetails.src}
                    alt={treatmentDetails.alt}
                    className='object-cover w-full h-full card-thumbnail'
                />
            </CardHeader>
            <CardBody>
                <Typography variant="h5" color="blue-gray" className="mb-2 text_PlayfairDisplay-VariableFont_wght">
                    {treatmentDetails.title}
                </Typography>
                <p className='line-clamp-3 leading-tight'>
                    {treatmentDetails.description}
                </p>
                <Typography variant='h6' className='px-3 py-1 text_OpenSans-VariableFont_wdth'>
                    Minimum duration  -  {treatmentDetails.duration}
                </Typography>
                <Typography className='px-3 text_OpenSans-VariableFont_wdth'>
                    Price -  {treatmentDetails.price}
                </Typography>
            </CardBody>
            <CardFooter className="pt-0">
                <Link to={`/Treatment/${treatmentDetails.title}`}>
                    <Button className='text_OpenSans-VariableFont_wdth'>Read More</Button>
                </Link>
            </CardFooter>
        </Card>
    );
}

export default TreatmentCard